<template>

	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">NAVER 로그인 진행중</h2>
				<p class="sub-tit">NAVER 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>

</template>

<script>

import $ from 'jquery'
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "naverReturn",
	data() {

		return {
			LOCAL: location.hostname,
			isKeepSession: this.$route.query.isKeepSession,
		}
	},
	created() {

		const self = this

		this.$loadScript("/ssflex/externals/naver/naverLogin_implicit-1.0.3.js")
		// this.$loadScript("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")
			.then((res) => {
				this.naverInit();
			})

	},
	updated() {

	},
	mounted() {

		this.appDeviceToken("#deviceToken")
	},
	methods: {


		naverInit () {

			const self = this

			let isKeepSession = true
			try {
				isKeepSession = $('#stay-login', opener.document).prop("checked");
			} catch (e) {
				isKeepSession = false
			}


			var naver_id_login = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_LOGIN_RETURN);

			let coCode = (location.origin + location.pathname)
				.split(
					this.$router.options.routes
						.map(e => e.children)
						.flat()
						.filter(e => e)
						.concat(this.$router.options.routes)
						.filter(e => e.name === this.$options.name)[0]
						.path
						.replace(/:(.*)[?]*/, "")
				)
				.at(-1)

			coCode = coCode === this.$options.name || coCode.startsWith(location.origin) ? "www" : coCode

			// 접근 토큰 값 출력
			// 네이버 사용자 프로필 조회
			naver_id_login.get_naver_userprofile((res) => {
				//alert(res.id);

				// 네이버 이메일 추출
				let email = res.email || null;

				// DONE : SNS 정보로 로그인 및 없을 경우 저장 후 가입폼으로
				// $.get(self.APIs.SESSION + "/doSnsLogin", {
				self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
					snsService: "naver",
					snsId: res.id,
					email: email,
					LOGIN_DOMAIN: coCode
				}, async (res) => {

					const result = res.data;
					if (result.status === "ok") {
						if (await self.setSessionProc(result.coAccountVO, opener)) {
							self.setSessionKeep( isKeepSession )

							// SSO 모드 확인
							// 네이버 setPopup() 콜백은 별도 창에서 열리므로 이 창의 sessionStorage에는
							// login.vue(naverLogin)에서 저장한 ssoParams가 없음. 부모 창(opener)에서 읽는다.
							let ssoParams = null;
							try {
								let ssoParamsStr = sessionStorage.getItem('ssoParams');
								if (!ssoParamsStr && window.opener) {
									try {
										ssoParamsStr = window.opener.sessionStorage.getItem('ssoParams');
										if (ssoParamsStr) {
											window.opener.sessionStorage.removeItem('ssoParams');
										}
									} catch (e) {
										console.log("SSO 파라미터(opener sessionStorage) 접근 실패:", e);
									}
								}
								if (ssoParamsStr) {
									ssoParams = JSON.parse(ssoParamsStr);
									sessionStorage.removeItem('ssoParams');
								}
							} catch (e) {
								console.log("SSO 파라미터 확인 실패:", e);
							}

							// SSO 모드면 SSO 처리
							if (ssoParams) {
								self.axiosCaller.post(self, self.APIs.SESSION + "/doSSOSnsLogin", {
									uuid: ssoParams.uuid,
									gid: ssoParams.gid,
									redirecturl: ssoParams.redirecturl
								}, (ssoRes) => {
									const ssoResult = ssoRes.data;
									if (ssoResult.status === "ok") {
										const redirectUrl = ssoResult.redirectUrl;
										const payload = {
											key: "sso_login_success",
											redirectUrl,
											code: redirectUrl ? redirectUrl.split("code=")[1]?.split("&")[0] : null
										};
										// 부모(상상박스 등)가 postMessage 로만 받는 경우를 위해 알림 (선택)
										if (window.opener && !window.opener.closed) {
											try {
												window.opener.postMessage(payload, "*");
											} catch (e) { /* ignore */ }
										}
										// 카카오 SSO: login.vue 가 로그인 팝업(현재 브라우징 맥락)을 redirectUrl 로 이동.
										// 네이버도 동일해야 함. opener 만 바꾸고 close() 하면 팝업 URL 에 code 가 안 남아
										// WebView/외부 프로그램이 팝업 주소만 감시할 때 실패함.
										if (redirectUrl) {
											window.location.href = redirectUrl;
										}
									} else {
										if (window.opener && !window.opener.closed) {
											window.opener.postMessage({
												key: "sso_login_fail",
												msg: ssoResult.msg || "SSO 로그인에 실패했습니다."
											}, location.origin);
											self.$nextTick(() => {
												window.opener.focus();
												close();
											});
										} else {
											self.swalUtils.fireSsoLicenseAuthGuide(ssoResult.msg);
										}
									}
								});
							} else {
								// 일반 모드
								self.goWithCoCode(self, (href) => {
									window.opener.postMessage({
										"key": "go",
										"to": href
									}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), coCode))
									close()
								})
							}
						}
					} else {
						let self = this

						window.opener.postMessage({
							"key": "alert",
							"icon": "info",
							"title": "Error",
							"content": result.msg
						}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), coCode))
						self.$nextTick(() => {
							close()
						})
					}
				})

			});
		},


		goReferrer () {
			const self = this

			if ( !this.stringUtils.isEmpty( this.$route.query.referrer ) ) {
				// console.log( this.$route.query.referrer )
				// opener.location.href = this.$route.query.referrer
				self.appClose({
					url: this.$route.query.referrer
				})
			} else {
				//opener.location.href = "/"
				self.appClose({
					url: "/"
				})
			}
		},

		naverSignInCallback() {

			// 네이버 사용자 프로필 조회 이후 프로필 정보를 처리할 callback function
			console.log( window.naver_id_login )
			alert(window.naver_id_login.getProfileData('email'));
			alert(window.naver_id_login.getProfileData('nickname'));
			alert(window.naver_id_login.getProfileData('age'));
		},

	}
}

</script>

<style scoped>

</style>
